import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { FC } from 'react';
import {
  ISelectComponent,
  ISelectOption,
  OptionMap,
  SelectField as SelectFieldType,
} from '../../../types';
import Field from '../field';
import styles from './styles.module.css';

const getSelectOptions = (options: ISelectOption[], optionsMap?: OptionMap) => (
  <>
    {options.map((option, i) => {
      const mapped = optionsMap ? optionsMap(option) : option;
      return (
        <option key={i} value={mapped.value}>
          {mapped.label}
        </option>
      );
    })}
  </>
);

const SelectComponent: FC<ISelectComponent> = props => {
  const {
    className = '',
    options,
    optionsMap,
    fullwidth = false,
    usePlaceholderChild = false,
    children,
    controlProps,
    ...selectProps
  } = props;

  if (!options && !children)
    throw new Error(
      'Invalid Select props: either pass options array or build up yourself as children'
    );

  const Options = options ? getSelectOptions(options, optionsMap) : children;

  const fullwidthClass = fullwidth ? 'is-fullwidth' : '';

  return (
    <div className={clsx('control', fullwidthClass)} {...controlProps}>
      <select
        className={clsx(styles.select, fullwidth ? styles.selectFullwidth : '', className)}
        {...selectProps}>
        {usePlaceholderChild && <option value="">Select one..</option>}
        {Options}
      </select>
      <FontAwesomeIcon icon={faCaretDown as IconProp} className={styles.caret} />
    </div>
  );
};

const SelectField: FC<SelectFieldType> = props => {
  const {
    label,
    labelProps,
    fullwidth = false,
    required = false,
    errorMessage,
    ...componentProps
  } = props;

  return (
    <Field
      label={label}
      labelProps={labelProps}
      fullwidth={fullwidth}
      required={required}
      errorMessage={errorMessage}>
      <SelectComponent fullwidth={fullwidth} required={required} {...componentProps} />
    </Field>
  );
};

export default {
  Component: SelectComponent,
  Field: SelectField,
};
